export function shouldForwardProp(prop: string) {
  return !prop.startsWith("$");
}
